// @ts-ignore
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { COOKIES_CONFIG } from '@belong/common';
import classNames from 'classnames/bind';
import Button from 'components/Button/Button';
import { BUTTON_TYPES } from 'components/Button/buttonTypes';
import HeaderMenuNavLink from 'components/HeaderMain/HeaderDesktopMenuComponent/HeaderMenuNavLink/HeaderMenuNavLink';
import { destroyCookie } from 'nookies';
import PropTypes from 'prop-types';
import { logOut } from 'store/redux/user/actions';
import { DEFAULT_LINKS } from '../../../consts/links';
import styles from './HeaderDesktopMenuComponent.module.css';

const cx = classNames.bind(styles);

const { REFERRAL_USER, REFERRAL_ID } = COOKIES_CONFIG;

class HeaderDesktopMenuComponent extends Component {
  static propTypes = {
    listOfLinks: PropTypes.array.isRequired,
    showSignOut: PropTypes.bool,
    menuClassName: PropTypes.string,
    firstName: PropTypes.string,
    location: PropTypes.object.isRequired,
    logOut: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  };

  static defaultProps = {
    showSignOut: false,
    menuClassName: '',
    firstName: false,
  };

  handleSignOut = async () => {
    try {
      const { logOut: logOutAction, history } = this.props;

      destroyCookie(null, REFERRAL_USER.name, { path: '/' });
      destroyCookie(null, REFERRAL_ID.name, { path: '/' });

      window?.cioanalytics?.reset();

      logOutAction();

      history.push('/');
    } catch (err) {
      console.error(err);
    }
  };

  isSelected = (to) => {
    const {
      location: { pathname },
    } = this.props;

    if (to === DEFAULT_LINKS.YOUR_PROFILE.to) {
      return to === pathname;
    }

    if (to === DEFAULT_LINKS.YOUR_HOME.to) {
      if (
        pathname.includes('accounts') &&
        pathname !== DEFAULT_LINKS.YOUR_PROFILE.to
      ) {
        return true;
      }
    }
    return false;
  };

  render() {
    const { listOfLinks, showSignOut, menuClassName } = this.props;
    return (
      <>
        <ul className={cx('menu-x', menuClassName)}>
          {listOfLinks.map((link, index) => [
            <HeaderMenuNavLink
              tabIndex="-1"
              {...link}
              key={index}
              selected={this.isSelected(link.to)}
            />,
          ])}
          {showSignOut && (
            <div>
              <li className="mb-2sm box-border border-0 border-l-4 border-solid border-transparent px-xs last:mb-0 hover:border-l-4 hover:border-navy">
                <Button
                  className={cx('link')}
                  buttonType={BUTTON_TYPES.TEXT}
                  onClick={this.handleSignOut}
                >
                  SIGN OUT
                </Button>
              </li>
            </div>
          )}
        </ul>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    logOut,
  })(HeaderDesktopMenuComponent),
);
